import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage.vue'
import TeamInvitePage from '../views/TeamInvitePage.vue'
import WithdrawPage from '../views/WithdrawPage.vue'
import InvestPage from '../views/InvestPage.vue'
import UserListPage from '../views/UserListPage.vue'
import GenesisNodePage from '../views/GenesisNodePage.vue'
import BalanceLogPage from '../views/BalanceLogPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  {
    path: '/team',
    name: 'team',
    component: TeamInvitePage
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    component: WithdrawPage
  },
  {
    path: '/invest',
    name: 'invest',
    component: InvestPage
  },
  {
    path: '/user-list',
    name: 'userList',
    component: UserListPage
  },
  {
    path: '/genesis-node',
    name: 'genesisNode',
    component: GenesisNodePage
  },
  {
    path: '/balance-logs',
    name: 'balanceLogs',
    component: BalanceLogPage
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.query.ref) {
    localStorage.setItem('ref_address', to.query.ref)
  }
  next()
})

export default router
